module.exports = __webpack_public_path__ + "img/01.96f23f1e.png";